"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.CalendarHeader = CalendarHeader;
exports.enhance = exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _is_same_month = _interopRequireDefault(require("date-fns/is_same_month"));

var _format = _interopRequireDefault(require("date-fns/format"));

var _withProps = _interopRequireDefault(require("recompose/withProps"));

var _Button = _interopRequireDefault(require("./Button"));

var enhance = (0, _withProps["default"])(function (props) {
  return {
    isPrevDisabled: !props.allValid && (0, _is_same_month["default"])(props.today, props.month)
  };
});
exports.enhance = enhance;

function CalendarHeader(_ref) {
  var month = _ref.month,
      onPreviousClick = _ref.onPreviousClick,
      onNextClick = _ref.onNextClick,
      isPrevDisabled = _ref.isPrevDisabled;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "calendar-header"
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    className: "previous",
    onClick: onPreviousClick,
    disabled: isPrevDisabled
  }, /*#__PURE__*/_react["default"].createElement("span", null, "Previous")), /*#__PURE__*/_react["default"].createElement("span", {
    className: "month"
  }, (0, _format["default"])(month, 'MMMM YYYY')), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    className: "next",
    onClick: onNextClick
  }, /*#__PURE__*/_react["default"].createElement("span", null, "Next")));
}

CalendarHeader.propTypes = {
  month: _propTypes["default"].instanceOf(Date),
  isPrevDisabled: _propTypes["default"].bool,
  onPreviousClick: _propTypes["default"].func,
  onNextClick: _propTypes["default"].func
};
CalendarHeader.defaultProps = {
  month: new Date()
};

var _default = enhance(CalendarHeader);

exports["default"] = _default;